"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flyout = exports.FlyoutItem = exports.NumberButtonContainer = exports.FlyoutContainer = exports.DEFAULT_LIMIT = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const R = __importStar(require("ramda"));
const react_1 = __importDefault(require("react"));
const victor_1 = __importDefault(require("victor"));
const styled_components_1 = __importDefault(require("styled-components"));
const style_1 = __importDefault(require("style"));
const constant_1 = require("../constant");
const NumberButton_1 = require("./NumberButton");
exports.DEFAULT_LIMIT = 3;
function toTransform({ position }) {
    return `translate(${position.x}px, ${position.y}px)`;
}
exports.FlyoutContainer = styled_components_1.default.div `
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: ${style_1.default.Depth.Position.F100};
`;
exports.NumberButtonContainer = styled_components_1.default.div `
  position: absolute;
  top: 0px;
  left: 0px;
  transform: ${toTransform};
`;
const ANGLE = (Math.PI); // 90 degrees.
/**
 * Flyout item.
 */
const FlyoutItem = ({ center, element, index, onChange, anchor, radius, step, value, }) => {
    // Determine if the item is selected.
    const isSelected = react_1.default.useMemo(() => {
        return element === value;
    }, [element, value]);
    // Determine the radians to rotate.
    const radians = react_1.default.useMemo(() => {
        const base = step * index - (Math.PI / 3);
        return anchor === constant_1.HorizontalDirection.Right ? base : base + Math.PI;
    }, [step, index, anchor]);
    // Determine the appropriate rotation for the item.
    const rotation = react_1.default.useMemo(() => {
        return radius.clone().rotateBy(radians);
    }, [radius, radians]);
    // Determine the position of the item.
    const position = react_1.default.useMemo(() => {
        return center.clone().add(rotation);
    }, [center, rotation]);
    return ((0, jsx_runtime_1.jsx)(exports.NumberButtonContainer, Object.assign({ position: position }, { children: (0, jsx_runtime_1.jsx)(NumberButton_1.NumberButton, { isSelected: isSelected, isDisabled: isSelected, onClick: () => {
                onChange(element);
            }, value: element }, `value-${element}`) })));
};
exports.FlyoutItem = FlyoutItem;
/**
 * Paginated flyout number picker.
 */
const Flyout = ({ anchor, limit = 3, onChange, value, values, }) => {
    const [page] = react_1.default.useState(0);
    const offset = react_1.default.useMemo(() => {
        return page * limit;
    }, [page, limit]);
    const active = react_1.default.useMemo(() => {
        return R.slice(offset, limit, values);
    }, [offset, limit, values]);
    const sorted = react_1.default.useMemo(() => {
        return anchor === constant_1.HorizontalDirection.Right ? active : active.reverse();
    }, [anchor, active]);
    const count = react_1.default.useMemo(() => {
        return R.length(active);
    }, [active]);
    const step = react_1.default.useMemo(() => {
        return ANGLE / count;
    }, [count]);
    const radius = new victor_1.default(65, 0);
    const center = new victor_1.default(0, 0);
    return ((0, jsx_runtime_1.jsx)(exports.FlyoutContainer, { children: R.addIndex(R.map)((element, index) => {
            return ((0, jsx_runtime_1.jsx)(exports.FlyoutItem, { anchor: anchor, element: element, radius: radius, center: center, index: index, onChange: onChange, step: step, value: value }, `element-${element}`));
        }, sorted) }));
};
exports.Flyout = Flyout;
